import React, { useState, useEffect, useMemo } from "react";
import { Formik, Form, FormikHelpers } from "formik";
import * as Yup from "yup";

//MUI
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import FormikControl from "../../components/formik/FormikControl";
import Loader from "../../components/loader/Loader";

import SBUBUMapService from "../../services/SBUBUMapService";
import { Mode } from "./SBUBUMappingPage";
import { SBUBUMapModel } from "../../models/SBUBUMapModel";
// import { statusOptions } from "../../utility/utils";
import { fetchSBUBUMaps } from "../../redux/actions/SBUBUMapActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { createAutocompleteOptions } from "../../utility/utils";
import ConfirmDialog from "../ConfirmDialog";

const validationSchema = Yup.object({
  SBUId: Yup.number().min(1, "Required").required("Required"),
  bUId: Yup.number().min(1, "Required").required("Required"),
  // status: Yup.string().required("Required"),
});

type FormProps = Yup.InferType<typeof validationSchema>;

type Props = {
  mode: Mode;
  handleModalClose: () => void;
  data?: SBUBUMapModel;
};

const SBUBUMappingForm = ({ mode, handleModalClose, data }: Props) => {
  const initialValues = useMemo(
    () => ({
      SBUId: 0,
      bUId: 0,
      // status: "",
    }),
    []
  );

  const [formState, setFormState] = useState<FormProps>(initialValues);
  const dispatch = useAppDispatch();
  const displayToast = useAppSelector((state) => state.toast.displayToast);
  const allSBUs = useAppSelector((state) => state.sbu.all_SBUs);
  const allBUs = useAppSelector((state) => state.bu.all_BUs);

  const SBUOptions = useMemo(() => {
    return createAutocompleteOptions(allSBUs, "sbuid", "name");
  }, [allSBUs]);

  const BUOptions = useMemo(() => {
    return createAutocompleteOptions(allBUs, "buid", "name");
  }, [allBUs]);

  useEffect(() => {
    if (mode === "delete" && data) {
      setFormState(() => ({
        SBUId: data.sbuid,
        bUId: data.buid,
        // status: data.isActive ? "active" : "inactive",
      }));
    }
  }, [mode, data]);

  const submitHandler = async (
    values: FormProps,
    actions: FormikHelpers<FormProps>
  ) => {
    try {
      let formData: SBUBUMapModel = {
        sbuid: 0,
        buid: 0,
        isActive: true,
        createdDate: new Date(),
      };
      if (mode === "add") {
        formData.sbuid = values.SBUId;
        formData.buid = values.bUId;
        // formData.isActive = values.status === "active" ? true : false;
      } else if (data) {
        formData = {
          ...data,
          sbuid: values.SBUId,
          buid: values.bUId,
          // isActive: values.status === "active" ? true : false,
        };
      }
      mode === "delete"
        ? await SBUBUMapService.deleteSBUBUMap(formData)
        : await SBUBUMapService.createSBUBUMap(formData);
      actions.setSubmitting(false);
      handleModalClose();
      dispatch(fetchSBUBUMaps());
      displayToast(
        `SBU-BU mapping ${mode === "add" ? "created" : "deleted"} successfully`,
        "success"
      );
    } catch (error) {
      actions.setSubmitting(false);
    }
  };
  return (
    <Formik
      initialValues={formState}
      validationSchema={validationSchema}
      onSubmit={submitHandler}
      enableReinitialize={true}
    >
      {(formik) => (
        <>
          <Form>
            {mode === "delete" ? (
              <ConfirmDialog handleModalClose={handleModalClose} />
            ) : (
              <Stack gap={2}>
                <FormikControl
                  control="autocomplete"
                  options={SBUOptions}
                  name="SBUId"
                  size="small"
                  label="SBU"
                  placeholder="Select SBU"
                />
                <FormikControl
                  control="autocomplete"
                  options={BUOptions}
                  name="bUId"
                  size="small"
                  label="BU"
                  placeholder="Select BU"
                />
                {/* <FormikControl
                  control="autocomplete"
                  options={statusOptions}
                  name="status"
                  size="small"
                  label="Status"
                  placeholder="Select Status"
                /> */}
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={formik.isSubmitting}
                >
                  Submit
                </Button>
              </Stack>
            )}
          </Form>
          {formik.isSubmitting && <Loader />}
        </>
      )}
    </Formik>
  );
};

export default SBUBUMappingForm;
